import { jsxs as e, Fragment as N, jsx as o } from "react/jsx-runtime";
import { useState as a, useEffect as F } from "react";
import { addCoupon as G } from "../api/addCoupon.js";
import { ModalHeader as J } from "../components/ModalHeader.js";
import { ModalFooter as K } from "../components/ModalFooter.js";
import { CouponCard as Q } from "../components/CouponCard.js";
import { NoCoupons as U } from "../components/NoCoupons.js";
import { Alert as V } from "../components/Alert.js";
import { InfoIcon as W } from "../../../assets/svgs/InfoIcon.js";
const E = ({
  account: b,
  orderFormId: x,
  hasItemsInCart: C,
  isIO: p,
  closeIOModal: u,
  coupons: c,
  firstCouponName: i,
  secondCouponName: _,
  replaceCoupon: w,
  setView: A,
  setActiveRule: D,
  setDataItem: L,
  setFirstCouponName: m,
  setSecondCouponName: n,
  setReplaceCoupon: B,
  setIsCloseModalEmpty: S,
  genericTaggingEvent: r
}) => {
  const [t, q] = a(""), [H, j] = a(!1), [M, s] = a(""), [f, d] = a(!1), [P, h] = a(!1), k = (l) => {
    l.preventDefault(), q(l.target.value);
  }, z = async (l) => {
    l.preventDefault();
    try {
      if (!i || i && w) {
        j(!0);
        const y = await G(b, x, t);
        B(!1), n(""), y.error.length <= 0 ? (r == null || r("discount_coupon", {
          name: "Cupom aplicado do input",
          couponName: t
        }), s("success"), h(!0), m(t), p && window.location.reload()) : (r == null || r("discount_coupon", {
          name: "Cupom do input expirado ou invalido",
          couponName: t,
          objectError: y.error
        }), s("error"), h(!1), m("")), d(!0);
      } else
        n(t), A("overwrite-view");
    } catch (y) {
      r == null || r("discount_coupon", {
        name: "Cupom do input - error na api",
        couponName: t
      }), s("error"), h(!1), d(!0);
    } finally {
      j(!1);
    }
  };
  return F(() => {
    f && setTimeout(() => d(!1), 5e3);
  }, [P, f]), /* @__PURE__ */ e(N, { children: [
    p && u && /* @__PURE__ */ o(
      J,
      {
        closeModal: u,
        title: "Meus Cupons",
        genericTaggingEvent: r
      }
    ),
    C ? /* @__PURE__ */ o("div", { className: "form-coupons", children: /* @__PURE__ */ e("form", { onSubmit: z, children: [
      /* @__PURE__ */ o(
        "input",
        {
          type: "text",
          placeholder: "Insira o cupom",
          value: t,
          onChange: k
        }
      ),
      /* @__PURE__ */ o("button", { type: "submit", name: "adicionar", disabled: H, children: "Adicionar" })
    ] }) }) : /* @__PURE__ */ o("div", { className: "cart-empty-coupons-label", children: /* @__PURE__ */ e("p", { children: [
      /* @__PURE__ */ o("span", { children: /* @__PURE__ */ o(W, {}) }),
      "Para adicionar um cupom é necessário que você adicione pelo menos 1 produto no carrinho"
    ] }) }),
    /* @__PURE__ */ o("div", { className: "container-title-coupons", children: c.length > 0 ? /* @__PURE__ */ e(N, { children: [
      /* @__PURE__ */ o("h2", { children: "Cupons disponíveis" }),
      /* @__PURE__ */ o("div", { className: "container-coupons", children: c.map((l) => /* @__PURE__ */ o(
        Q,
        {
          account: b,
          orderFormId: x,
          hasItemsInCart: C,
          isIO: p,
          item: l,
          firstCouponName: i,
          secondCouponName: _,
          replaceCoupon: w,
          setView: A,
          setFirstCouponName: m,
          setSecondCouponName: n,
          setActiveRule: D,
          setDataItem: L,
          setReplaceCoupon: B,
          setAlert: d,
          setType: s,
          setIsCloseModalEmpty: S,
          genericTaggingEvent: r
        },
        l.couponName
      )) })
    ] }) : /* @__PURE__ */ o(U, {}) }),
    f && /* @__PURE__ */ o(V, { type: M }),
    p && u && /* @__PURE__ */ o(
      K,
      {
        isFloating: c.length > 0,
        cancelButtonAction: u,
        cancelButtonText: "Sair"
      }
    )
  ] });
};
export {
  E as CouponsView
};
